module.exports = __webpack_public_path__ + "img/holywoodskyline-default.39f9fde0.jpg";